import moment from 'moment'

import { useQuery } from '@tanstack/react-query'
import { GRAPHQL_ENDPOINT, STRAPI_API_URL } from '../../config'
import { graphql } from '../../gql'
import request from 'graphql-request'
import { EventsQueryQuery } from '../../gql/graphql'
import { updateDraftAttributes } from '../../utils/updateDraftAttributes'

export const EVENTS_QUERY_KEY = 'events_query'

export const BASE_API_ENDPOINT = new URL('/api/events', STRAPI_API_URL)

export type Event = NonNullable<EventsQueryQuery['events']>['data'][0]

const previewNewsQuery = graphql(/* GraphQL */`
query PreviewNewsQuery($slug: String!) {
  newss(
    filters: {
      slug: {
        eq: $slug
      }
    },
    publicationState: PREVIEW
  ) {
    data {
      id
      attributes {
        slug
        title
        author
        publishedDate
        shortDescription
        content
        contactUsPubInfo
        draftJson
        image {
          data {
            attributes {
              url
            }
          }
        }
        video {
          videoDescription
          videoTitle
          videoUrl
        }
      }
    }
  }
}
`)

export const usePreviewNews = (slug: string) => {
  const {data, isLoading, error} = useQuery([
    'preview_news',
    slug,
  ], async () => {
    const result = await request(GRAPHQL_ENDPOINT, previewNewsQuery, {
      slug
    })

    const newsItem = result?.newss?.data?.[0]

    if (newsItem.attributes.draftJson) {
      try {
        const draftData = JSON.parse(newsItem.attributes.draftJson);

        const draftAttributes = updateDraftAttributes({
          attributes: newsItem.attributes,
          draft: draftData,
          imageKeys: ['image']
        })

        newsItem.attributes = draftAttributes
      } catch (e) {}
    }

    return newsItem
  })

  return {
    data,
    isLoading,
    error
  }
}


